import React from 'react';
export function Offer() {
  return <section className="mb-24" data-id="element-286">
      <h2 className="text-[28px] sm:text-[32px] md:text-[36px] font-semibold text-[#1B2951] mb-8 leading-tight font-['Playfair_Display']" data-id="element-287">
        A Special Offer for Early Adopters
      </h2>
      <div className="bg-gradient-to-br from-[#FFB88C] to-[#FFE5D9] border border-[#FFB88C]/50 rounded-lg p-8 shadow-md" data-id="element-288">
        <div className="text-center mb-8" data-id="element-289">
          <h3 className="text-xl font-bold text-[#1B2951] uppercase font-['Poppins']" data-id="element-290">
            LIMITED TIME OFFER
          </h3>
        </div>
        <div className="grid md:grid-cols-2 gap-8" data-id="element-291">
          <div data-id="element-292">
            <ul className="space-y-4" data-id="element-293">
              <li className="flex items-start" data-id="element-294">
                <span className="text-[#27AE60] mr-3 mt-1" data-id="element-295">✅</span>
                <p className="text-[#1B2951] font-['Inter']" data-id="element-296">
                  25% OFF your first 2 months (Save ₹825)
                </p>
              </li>
              <li className="flex items-start" data-id="element-297">
                <span className="text-[#27AE60] mr-3 mt-1" data-id="element-298">✅</span>
                <p className="text-[#1B2951] font-['Inter']" data-id="element-299">
                  FREE consultation with nutritionist
                </p>
              </li>
              <li className="flex items-start" data-id="element-300">
                <span className="text-[#27AE60] mr-3 mt-1" data-id="element-301">✅</span>
                <p className="text-[#1B2951] font-['Inter']" data-id="element-302">
                  FREE Nihaal's personal skin & hair guide
                </p>
              </li>
              <li className="flex items-start" data-id="element-303">
                <span className="text-[#27AE60] mr-3 mt-1" data-id="element-304">✅</span>
                <p className="text-[#1B2951] font-['Inter']" data-id="element-305">
                  FREE shipping anywhere in India
                </p>
              </li>
              <li className="flex items-start" data-id="element-306">
                <span className="text-[#27AE60] mr-3 mt-1" data-id="element-307">✅</span>
                <p className="text-[#1B2951] font-['Inter']" data-id="element-308">
                  30-day money-back guarantee
                </p>
              </li>
            </ul>
          </div>
          <div className="flex flex-col justify-center" data-id="element-309">
            <div className="mb-6 rounded-lg overflow-hidden shadow-lg" data-id="element-310">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qkCG6ZJjjQtKAL6rQTHqD9/Skin_Youthful_2025_PDP_-_1.jpg" alt="Biohack Skin Aging with Cerafusion - New & Improved Formulation" className="w-full h-auto" data-id="element-311" />
            </div>
            <button className="bg-gradient-to-r from-[#FF8E72] to-[#FFB88C] hover:from-[#FF8E72] hover:to-[#FF8E72] text-white font-bold py-4 px-6 rounded-lg text-lg mb-4 transition duration-300 ease-in-out transform hover:scale-105 shadow-md font-['Poppins']" data-id="element-312">
              CLAIM YOUR 25% DISCOUNT NOW
            </button>
            <div className="text-center" data-id="element-313">
              <p className="text-[#1B2951] font-medium font-['Poppins']" data-id="element-314">
                Offer ends in 23:47:52
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}